export default "__VITE_ASSET__BwTOr3$___"